import { DeviceConfig, isDeviceConfig } from '@iotv/datamodel-core';
import { AdjacentType, isNonNaNNumber, objectsMatch } from '@iotv/iotv-v3-types';
const debug = process.env.REACT_APP_DEBUG && false;
export function getScheduleContextInfo({ scheduler, entity, nodeEdgeMapper, programme }) {
    let broadcastDataMatches = false;
    let requestedConfigMatches = false;
    let requestedConfigDisabled = false;
    let reportedConfigMatches = false;
    let requestIsInFlight = false;
    /** the configured context as per the UI */
    const schedulerContext = scheduler.context;
    let lastUpdated = null;
    try {
        const schedulerHasItem = !!scheduler.context.getItem(entity);
        if (schedulerHasItem) {
            const window = scheduler.getWindowForItem(entity);
            if (programme && window) {
                const thisOnDemandProgrammeSchedule = Array.from({ length: programme.repeats ?? 0 }, (_, i) => programme.getOnDemandProgrammeConfigForWindow(window.window + programme.windows * i, true));
                const devices = schedulerContext.getNodesByPath(entity, [{ adjacencyType: AdjacentType.CHILD, objectTypeId: 'Device' }]);
                if (devices.length === 0) {
                    console.log(`WARN: NO DEVICES!`, schedulerContext.getSummary());
                }
                if (devices.length === 1) {
                    const currentDeviceConfig = nodeEdgeMapper.getItem(DeviceConfig.createForDevice(devices.at(0)));
                    if (isDeviceConfig(currentDeviceConfig)) {
                        debug && console.log('getScheduleContextInfo', devices[0].name, 'config', programme, entity, window, currentDeviceConfig);
                        const { reported, requested, metadata, lastReportedMs, lastRequestedMs, lastRequestedBroadcastScheduleSk } = currentDeviceConfig;
                        if (isNonNaNNumber(metadata?.lastUpdatedMs)) {
                            lastUpdated = metadata.lastUpdatedMs;
                        }
                        /** broadcastData */
                        const broadcastScheduleMatches = programme.sk === lastRequestedBroadcastScheduleSk;
                        const broadcastTimeNewer = programme.appliedTimestamps?.[0] !== undefined && programme.appliedTimestamps[0] <= (lastUpdated ?? 0);
                        broadcastDataMatches = broadcastScheduleMatches && broadcastTimeNewer;
                        debug && console.log('getScheduleContextInfo', devices[0].name, 'schedule', broadcastDataMatches, broadcastScheduleMatches, broadcastTimeNewer);
                        if (requested) {
                            const { scheduleSet, rollingPatternMode } = requested;
                            requestedConfigDisabled = rollingPatternMode.startTimeUtcSeconds === 0;
                            requestedConfigMatches = objectsMatch(thisOnDemandProgrammeSchedule ?? { never: true }, scheduleSet);
                            debug && console.log('getScheduleContextInfo', devices[0].name, 'request', requestedConfigMatches, thisOnDemandProgrammeSchedule, scheduleSet);
                        }
                        if (reported) {
                            const { scheduleReport } = reported;
                            if (scheduleReport) {
                                const { config } = scheduleReport;
                                reportedConfigMatches = objectsMatch(thisOnDemandProgrammeSchedule ?? { never: true }, config.slice(0, programme.repeats));
                                debug &&
                                    console.log('getScheduleContextInfo', devices[0].name, 'report', reportedConfigMatches, thisOnDemandProgrammeSchedule, config.slice(0, programme.repeats));
                            }
                        }
                        if (requested && reported) {
                            const { scheduleSet } = requested;
                            const { scheduleReport } = reported;
                            if (scheduleReport) {
                                const { config } = scheduleReport;
                                requestIsInFlight = !objectsMatch(scheduleSet, config.slice(0, programme.repeats));
                                debug &&
                                    console.log('getScheduleContextInfo', devices[0].name, 'in-flight', requestIsInFlight, thisOnDemandProgrammeSchedule, scheduleSet, config.slice(0, programme.repeats));
                            }
                        }
                    }
                    else {
                        debug && console.log(`WARN: ScheduleStatus, no deviceConfig for `, { entity, devices });
                    }
                }
                if (devices.length > 1) {
                    console.log(`WARN: more than one device retreived, not supporting this here`);
                }
            }
            else {
                debug && console.log(`WARN: ScheduleStatus, no window for `, { entity });
            }
        }
    }
    catch (e) {
        debug && console.log(`ERROR extracting schedule context info for entity ${entity.sk} with error:`, e);
    }
    return {
        broadcastDataMatches,
        requestedConfigMatches,
        requestedConfigDisabled,
        reportedConfigMatches,
        requestIsInFlight,
    };
}
